var map = {
	"./vue-include": "2b0e",
	"./vue-include.vue": "2b0e",
	"./vue-include/default/dash": "2768",
	"./vue-include/default/dash.vue": "2768",
	"./vue-include/default/no-content": "e99b",
	"./vue-include/default/no-content.vue": "e99b",
	"./vue-include/error": "ab37",
	"./vue-include/error.vue": "ab37"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "13c4";
module.exports = webpackAsyncContext;